// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { DimensionRowOut } from './dimensionRowOut.zod.ts';

export const DimensionsOut = zod.object({
  "dimensions": zod.array(DimensionRowOut),
  "threshold": zod.int()
});

export type DimensionsOut = zod.input<typeof DimensionsOut>;
export type DimensionsOutOutput = zod.output<typeof DimensionsOut>;
